"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const UI_1 = require("~/components/UI");
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const routes_1 = require("~/consts/routes");
const redux_1 = require("redux");
const actions_1 = require("~/store/project/actions");
const selectors_1 = require("~/store/project/selectors");
const utils_1 = require("~/utils/utils");
const EditProjectForm_1 = __importDefault(require("~/components/ProjectManagement/EditProjectForm"));
const react_helmet_async_1 = require("react-helmet-async");
const useSubmissionGuard_1 = __importDefault(require("~/hooks/useSubmissionGuard"));
const CreateProjectModal_module_scss_1 = __importDefault(require("./CreateProjectModal.module.scss"));
function CreateProjectModal() {
    const { t } = (0, react_i18next_1.useTranslation)('project');
    const navigate = (0, react_router_dom_1.useNavigate)();
    const createdProject = (0, react_redux_1.useSelector)(selectors_1.selectCreatedProject);
    const [isSubmitDisabled, setIsSubmitDisabled] = (0, react_1.useState)(true);
    const [project, setProject] = (0, react_1.useState)(null);
    const { isSubmitting, trySubmit } = (0, useSubmissionGuard_1.default)();
    const { dispatchCreateProject, dispatchCreateProjectSuccess } = (0, redux_1.bindActionCreators)({
        dispatchCreateProject: actions_1.createProject,
        dispatchCreateProjectSuccess: actions_1.createProjectSuccess,
    }, (0, react_redux_1.useDispatch)());
    const submitHandler = () => {
        trySubmit(() => {
            if (project) {
                dispatchCreateProject(project);
            }
        });
    };
    const cancelProjectCreation = () => {
        navigate(-1);
    };
    (0, react_1.useEffect)(() => {
        setIsSubmitDisabled(!(project === null || project === void 0 ? void 0 : project.name));
    }, [project]);
    (0, react_1.useEffect)(() => {
        if (createdProject) {
            navigate(routes_1.ROUTE_PROJECT.replace(':projectId', String(createdProject.id)));
            dispatchCreateProjectSuccess(null);
            (0, utils_1.resetScene)();
        }
    }, [createdProject]);
    return (react_1.default.createElement(UI_1.ContentListModal, { headlineContent: react_1.default.createElement("div", { className: CreateProjectModal_module_scss_1.default.header },
            react_1.default.createElement(react_helmet_async_1.Helmet, null,
                react_1.default.createElement("title", null, "Create Project | TBUILD")),
            react_1.default.createElement("div", { className: CreateProjectModal_module_scss_1.default.title }, t('create-project')),
            react_1.default.createElement("div", { className: CreateProjectModal_module_scss_1.default.controls },
                react_1.default.createElement(UI_1.Button, { variant: "default", onClick: cancelProjectCreation }, t('cancel')),
                react_1.default.createElement(UI_1.Button, { variant: "primary", onClick: submitHandler, disabled: isSubmitDisabled || isSubmitting }, t('create')))), mainContent: react_1.default.createElement("div", { className: CreateProjectModal_module_scss_1.default.main },
            react_1.default.createElement(EditProjectForm_1.default, { onChange: setProject, isNew: true })) }));
}
exports.default = CreateProjectModal;
